import React, { useEffect, useState } from "react";
import CongratsInfo from "../modules/CongratsInfo";
import Button from "../modules/Button";
import textImg from "../../Assets/svg/text-img1.svg";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlumniOption from "./AlumniOption";
import ModalComponent from "../modules/Modal";
import doc from "../../Assets/svg/doc icon.svg";
import { api } from "../../Services";
import { addWebinar } from "../Connect/redux/actions";
import MentorStar from "../../Assets/svg/MentorStar";
import pic1 from "../../Assets/pic1.jpg";
import pic5 from "../../Assets/pic5.jpg";
import pic4 from "../../Assets/pic4.jpg";
import pic3 from "../../Assets/pic3.jpg";


function AwardedScreen(props) {
  const dispatch =useDispatch()
    const [btn, setBtn] = useState(true);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const navigate = useNavigate();
  const webinar = useSelector((state) => state.connect.webinar);

  const [ModalData, setModalData] = useState({
    show: false,
    type: "",
    title: (
      <div
        style={{
          width: "90%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <img style={{ marginRight: "2%" }} src={doc} alt="doc" />
        Terms and Conditions
      </div>
    ),
    countDown: " ",
    desc: "",
  });
  const getDisForm = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/disburse-form");
    navigate("/application/disburse-form");
  };
  const getMedia = async () => {
    try {
      const media = await api.getYoutube(tokenData.token);
       if(media.data){
        dispatch(addWebinar(media.data.webinarLink))
       }
        console.log('youtube', media)
    } catch (err) {
      console.log('err',err)
    }
  };
  useEffect(() => {
    getMedia()
  }, []);
  return (
    <div className="awarded-screen">
      <CongratsInfo name={props.personalInfo?.firstName} />
      {(!tokenData?.showBank || !tokenData?.showSpoc) && (
        <div className="disbursement-option">
          <div className="dis-left">
            <div className="dis-top">Scholarship Disbursement Form</div>
            <div className="dis-btm">
              We would need information regarding your college campus bank
              account to disburse the scholarship amount
            </div>
          </div>
          <div className="dis-right">
            <Button
              onClickHandler={() => getDisForm()}
              type={"contained"}
              value={"Add details"}
            />
          </div>
        </div>
      )}
      <div className="career-option">
        <div className="dis-left">
          <div className="form-title">
            Build an strong career with{" "}
            <span style={{ color: "#9B1E26" }}>IMPACT</span> mentors{" "}
          </div>
          <div className="dis-btm">
            We are pleased to offer you the opportunity to book one-on-one
            sessions with experienced professionals from IDFC FIRST Bank. These
            sessions cover a wide range of topics, allowing you to expand your
            network, and enhance your knowledge across domains.
          </div>
          <Button
            onClickHandler={() =>  navigate("/application/connect")}
            type={"contained"}
            value={"Get Started"}
          />
        </div>
        <div className="dis-left dis-right">
          {/* <img src={textImg} alt="text img" /> */}
          {/* <img src={mentorStar} alt="text img" /> */}
          <div className="pic1">
            <img src={pic1} alt="pic1"/>
          </div>
          <div className="pic2">
            <img src={pic5} alt="pic1"/>
          </div>
          <div className="pic3">
            <img src={pic4} alt="pic1"/>
          </div>
          <div className="pic4">
            <img src={pic3} alt="pic1"/>
          </div>
          <MentorStar/>

        </div>
      </div>
      <AlumniOption />
      <div className="media-section">
        <div className="media-left">
          <div className="form-title">
            Let's now start learning, with IDFC FIRST Bank Playlists
          </div>
          <div className="dis-btm">
            Explore more than 1000 videos, and improve your skills, for future
            endeavours.
          </div>
          <Button
            onClickHandler={() =>
              window.open("https://www.youtube.com/@idfcfirstbanksocial")
            }
            type={"contained"}
            value={"Learn More"}
          />
        </div>
        <div className="media-right">
          <iframe
            width="560"
            height="315"
            // src="https://www.youtube.com/embed/ocRperD5x50?si=kMK_s9ChER3RZ9lm"
            src={webinar}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          {/* {webinar} */}
        </div>
      </div>
  
    </div>
  );
}

export default AwardedScreen;
